
import { Component, Vue } from 'vue-property-decorator'

import BacButton from '../../components/BacButton.vue'
import BacModal from '../../components/BacModal.vue'
import BacInput from '../../components/BacInput.vue'

import { RallyLink } from '../../lib/models/RallyLink'
import { NotificationService } from '../../lib/utils/NotificationService'
import { Rally } from '../../lib/models/Rally'

@Component({
  components: {
    BacButton,
    BacModal,
    BacInput
  }
})
export default class Rallies extends Vue {
  rallyLinks: RallyLink[] = []

  selectedRallyLink = new RallyLink()
  isSaving = false

  RallyLink = RallyLink

  headers = [
    { text: 'Überschrift', value: 'heading', width: 80 },
    { text: 'Link Text', value: 'linkText', width: 30 },
    { text: 'Link', value: 'link', width: 30 },
    { text: 'Newsletter Type', value: 'newsletterType', width: 30 },
    { text: 'Newsletter statt Link', value: 'newsletter', width: 30 },
    { text: 'Rally', value: 'rally', width: 30 },
    { text: 'Aktiv', value: 'active', width: 30 },
    { text: 'Aktionen', value: 'actions', width: 30 }
  ];

  get items () {
    return this.rallyLinks.map(rallyLink => {
      rallyLink.rally = this.rallies.find((rally: Rally) => rally.id === rallyLink.rallyId)
      return rallyLink
    })
  }

  get rallies () {
    return this.$store.state.Rally.rallies
  }

  mounted () {
    this.$store.dispatch('loadRallies')
    this.loadRallyLinks()
  }

  async loadRallyLinks () {
    this.rallyLinks = await RallyLink.getAll({})
  }

  async saveRallyLink () {
    if (this.isSaving) {
      return
    }
    this.isSaving = true
    if (!this.selectedRallyLink.id) {
      try {
        await this.selectedRallyLink.create()
      } catch (ex) {
        this.isSaving = false
        NotificationService.notify('Rally Link konnte nicht gespeichert werden, etwas ging schief! Bitte melde dich beim Entwickler!')
        console.error('Error in Rally Link create')
      }
    } else {
      try {
        await this.selectedRallyLink.update()
      } catch (ex) {
        this.isSaving = false
        NotificationService.notify('Rally Link konnte nicht gespeichert werden, etwas ging schief! Bitte melde dich beim Entwickler!')
        console.error('Error in Rally Link update')
      }
    }
    this.selectedRallyLink = new RallyLink()
    await this.loadRallyLinks()
    this.isSaving = false
  }

  async deleteRallyLink () {
    if (this.isSaving) {
      return
    }
    this.isSaving = true

    try {
      await RallyLink.delete(this.selectedRallyLink.id)
    } catch (ex) {
      this.isSaving = false
      NotificationService.notify('Rally Link konnte nicht gelöscht werden, etwas ging schief! Bitte melde dich beim Entwickler!')
      console.error('Error in Rally Link delete')
    }

    await this.loadRallyLinks()
    this.isSaving = false
  }
}
